  import firebase from 'firebase/app'
  import firestore from 'firebase/firestore'
  // Initialize Firebase
  var config = {
    apiKey: "AIzaSyCbMGJ7AwFTvj_Vam3kn6EAnn2BHZhFb5o",
    authDomain: "stock-sys.firebaseapp.com",
    databaseURL: "https://stock-sys.firebaseio.com",
    projectId: "stock-sys",
    storageBucket: "stock-sys.appspot.com",
    messagingSenderId: "807152572794"
  };
  // var config = {
  //   apiKey: "AIzaSyBtgJzis8-ubfUH94-7V9IDcQnbUaHKPeU",
  //   authDomain: "mndcon.firebaseapp.com",
  //   databaseURL: "https://mndcon.firebaseio.com",
  //   projectId: "mndcon",
  //   storageBucket: "mndcon.appspot.com",
  //   messagingSenderId: "902748765774"
  // };
  const firebaseApp = firebase.initializeApp(config);
  firebaseApp.firestore().settings({timestampsInSnapshots:true});
  export default firebaseApp.firestore()


// WEBPACK FOOTER //
// ./src/firebase/init.js